import executeQuery from "#lib/db"

export const getCategories = async () => {
	const list = await executeQuery({
		query: `
			select
				categories.*,
				(
					select
						count(recipeID)
					from
						recipes
					where
						recipes.categoryID = categories.categoryID
				) as recipeCount
			from
				categories
		`,
	})

	return list
}
